var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.content)?_c('carousel',{attrs:{"content":_vm.content,"headline":_vm.headline,"products":_vm.products}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }